
(function () {
  function initTKCPurchasePanel(panel) {
    if (!panel || panel.dataset.tkcReady === 'true') return;
    panel.dataset.tkcReady = 'true';

    var sectionId = panel.dataset.sectionId;
    var variantInput = panel.querySelector('[data-tkc-variant-id]');
    var addButton = panel.querySelector('[name="add"]');
    var addButtonText = panel.querySelector('.m-add-to-cart--text');
    var priceNode = panel.querySelector('[data-tkc-price]');
    var availabilityNode = panel.querySelector('[data-tkc-availability]');
    var variantsNode = panel.parentElement && panel.parentElement.querySelector('[data-tkc-variants]');
    var quantityInput = panel.querySelector('.m-quantity__input');

    if (!variantInput || !variantsNode) return;

    var variants = {};
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (error) {
      return;
    }

    function updateQuantityRules(variant) {
      if (!quantityInput || !variant) return;
      var min = Number(variant.min || 1);
      var step = Number(variant.step || 1);

      quantityInput.dataset.min = String(min);
      quantityInput.min = String(min);
      quantityInput.step = String(step);

      if (variant.max !== null && variant.max !== undefined && variant.max !== '') {
        quantityInput.dataset.max = String(variant.max);
        quantityInput.max = String(variant.max);
      } else {
        delete quantityInput.dataset.max;
        quantityInput.removeAttribute('max');
      }

      var current = Number(quantityInput.value || min);
      if (current < min) quantityInput.value = String(min);
    }

    function updatePanel(variantId) {
      var variant = variants[String(variantId)];
      if (!variant) return;

      variantInput.value = String(variantId);
      updateQuantityRules(variant);

      if (priceNode && variant.price) {
        priceNode.textContent = variant.price;
      }

      if (availabilityNode) {
        availabilityNode.innerHTML =
          '<span class="tkc-purchase-panel__dot"></span><span>' +
          (variant.available
            ? (window.MinimogStrings && window.MinimogStrings.inStock ? window.MinimogStrings.inStock : 'In stock')
            : (window.MinimogStrings && window.MinimogStrings.soldOut ? window.MinimogStrings.soldOut : 'Sold out')) +
          '</span>';
      }

      if (addButton) {
        addButton.disabled = !variant.available;
      }

      if (addButtonText) {
        addButtonText.textContent = variant.available
          ? (window.MinimogStrings && window.MinimogStrings.addToCart ? window.MinimogStrings.addToCart : 'Add to cart')
          : (window.MinimogStrings && window.MinimogStrings.soldOut ? window.MinimogStrings.soldOut : 'Sold out');
      }
    }

    if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
      window.MinimogEvents.subscribe(window.MinimogTheme.pubSubEvents.variantChange, function (event) {
        if (!event || !event.data) return;
        if (String(event.data.sectionId) !== String(sectionId)) return;
        if (event.data.variant && event.data.variant.id) {
          updatePanel(event.data.variant.id);
        }
      });
    }

    updatePanel(variantInput.value);
  }

  function initAll() {
    document.querySelectorAll('[data-tkc-purchase-panel]').forEach(initTKCPurchasePanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
